import { ClaimDeletionPreviewDto, ClaimWithCheckoutRelationsDTOStatusEnum } from '@reposit/api-client';

interface ClaimDeletionButtonState {
  disabled: boolean;
  tooltip?: string;
}

export const isClaimDeletionAllowed = (
  hasClaimDeleteRole: boolean,
  claimStatus: ClaimWithCheckoutRelationsDTOStatusEnum,
): boolean =>
  hasClaimDeleteRole &&
  (claimStatus === ClaimWithCheckoutRelationsDTOStatusEnum.DRAFT ||
    claimStatus === ClaimWithCheckoutRelationsDTOStatusEnum.AWAITINGRESPONDENTS ||
    claimStatus === ClaimWithCheckoutRelationsDTOStatusEnum.DEACTIVATED);

const formatBlockingReason = (reason: string): string => {
  const [type, countOrStatus] = reason.split('=');
  const count = Number(countOrStatus);
  const plural = count === 1 ? '' : 's';

  switch (type) {
    case 'later proposal rounds':
      return 'The claim has progressed beyond the first proposal round.';
    case 'tenant responses':
      return 'The tenant has responded to the claim.';
    case 'arbitration':
      return `${count} arbitration record${plural} linked to the claim.`;
    case 'evidenceChasers':
      return `${count} evidence chaser${plural} linked to the claim.`;
    case 'orders':
      return `${count} order${plural} linked to the claim.`;
    case 'status':
      return `The claim status (${countOrStatus}) is not eligible for deletion.`;
    default:
      return reason;
  }
};

export const getClaimDeletionButtonState = (
  preview: ClaimDeletionPreviewDto | undefined,
  isPreviewing: boolean,
): ClaimDeletionButtonState => {
  if (isPreviewing) {
    return {
      disabled: true,
      tooltip: 'Checking whether this claim can be deleted.',
    };
  }

  if (!preview) {
    return {
      disabled: true,
      tooltip: 'Unable to check whether this claim can be deleted.',
    };
  }

  if (preview.blockingReasons.length) {
    return {
      disabled: true,
      tooltip: `Cannot delete: ${preview.blockingReasons.map(formatBlockingReason).join(' ')}`,
    };
  }

  return { disabled: false };
};
